import { render, staticRenderFns } from "./AlsokPanel.vue?vue&type=template&id=01a4e92a&scoped=true"
import script from "./AlsokPanel.vue.js?vue&type=script&lang=js&external"
export * from "./AlsokPanel.vue.js?vue&type=script&lang=js&external"
import style0 from "./AlsokPanel.vue?vue&type=style&index=0&id=01a4e92a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4e92a",
  null
  
)

export default component.exports